import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

const team = [
  {
    name: "James Thorpe",
    role: "Founder & Executive Chairman",
    bio: "James founded Thorpe Property Development Ltd in Leeds in June 2005 after a decade identifying the structural undersupply of supported housing across Yorkshire and the North. His conviction that government-backed social housing represented the UK's most resilient asset class formed the firm's bedrock. Over 20 years he has grown the portfolio from a single West Yorkshire acquisition to 12+ properties with £20M+ AUM.",
    image: "https://readdy.ai/api/search-image?query=real%20photo%20of%20senior%20British%20businessman%20aged%2057%2C%20salt%20and%20pepper%20short%20hair%2C%20wearing%20a%20plain%20dark%20navy%20suit%2C%20sitting%20at%20a%20wooden%20desk%20near%20a%20window%20in%20a%20real%20Leeds%20office%2C%20overcast%20natural%20daylight%2C%20slight%20smile%2C%20candid%20unposed%20shot%2C%20editorial%20magazine%20photography%20style%2C%20shallow%20depth%20of%20field%2C%20authentic%20and%20genuine%2C%20bookshelves%20softly%20out%20of%20focus%20behind%20him&width=400&height=480&seq=431&orientation=portrait",
  },
  {
    name: "Eleanor Hayes",
    role: "Chief Executive Officer",
    bio: "Eleanor joined Thorpe Property Development in 2007 as Head of Acquisitions and was appointed CEO in 2014. With over 25 years in structured real estate finance, she led the 2015 structured product launch, the 2018 NASDAQ Dubai listing, and the 2022 rebrand to Thorpe Dellow. She holds an MSc in Real Estate Finance from the University of Reading.",
    image: "https://readdy.ai/api/search-image?query=real%20photo%20of%20a%20British%20woman%20aged%2051%2C%20medium%20length%20brown%20hair%20with%20some%20grey%2C%20wearing%20a%20dark%20blazer%2C%20sitting%20in%20a%20well-lit%20modern%20office%20in%20Yorkshire%2C%20natural%20window%20light%20from%20the%20left%20side%2C%20genuine%20relaxed%20expression%2C%20not%20posed%2C%20documentary%20corporate%20photography%2C%20blurred%20desks%20and%20office%20plants%20behind%2C%20candid%20editorial%20style%2C%20real%20person&width=400&height=480&seq=432&orientation=portrait",
  },
  {
    name: "Daniel Reeves",
    role: "Head of Investment Structuring",
    bio: "Daniel joined in 2010 after eight years as a government housing adviser at the Department for Levelling Up, Housing and Communities. He architected the firm's SPV structure, established the independent Security Trustee framework, and negotiated the first FRI lease partnership in 2013. He has overseen over £80M in structured social housing transactions.",
    image: "https://readdy.ai/api/search-image?query=real%20candid%20photo%20of%20British%20man%20aged%2045%2C%20short%20dark%20brown%20hair%2C%20clean%20shaven%2C%20wearing%20a%20white%20collared%20shirt%20no%20tie%2C%20leaning%20slightly%20against%20a%20wall%20in%20a%20real%20office%20corridor%2C%20natural%20indirect%20light%2C%20relaxed%20friendly%20expression%2C%20editorial%20documentary%20style%2C%20shallow%20depth%20of%20field%2C%20out%20of%20focus%20office%20background%2C%20genuine%20not%20staged&width=400&height=480&seq=433&orientation=portrait",
  },
  {
    name: "Margaret Blackwell",
    role: "Chief Financial Officer",
    bio: "A Chartered Accountant with 22 years in alternative asset management, Margaret joined in 2016 to lead financial governance ahead of the NASDAQ Dubai listing. She oversees all investor reporting, monthly distributions, and HMRC compliance — ensuring the highest standards of financial transparency across the entire portfolio.",
    image: "https://readdy.ai/api/search-image?query=real%20photo%20of%20a%20British%20woman%20aged%2048%2C%20short%20neat%20blonde%20grey%20hair%2C%20wearing%20a%20light%20grey%20blazer%2C%20standing%20near%20a%20large%20window%20in%20a%20modern%20UK%20office%2C%20natural%20overcast%20daylight%2C%20composed%20but%20natural%20expression%2C%20not%20a%20studio%20shot%2C%20editorial%20documentary%20style%2C%20softly%20blurred%20office%20environment%20behind%20her%2C%20authentic%20real%20person%20feel&width=400&height=480&seq=434&orientation=portrait",
  },
  {
    name: "Charlotte Pemberton",
    role: "Head of Investor Relations",
    bio: "Charlotte joined in 2019 bringing 12 years of alternative investment distribution experience across private equity and real assets. She leads all investor communications, manages HNW and sophisticated investor onboarding, and oversees the firm's growing network of IFA and family office relationships. She holds a BA (Hons) in Economics from the University of Exeter.",
    image: "https://readdy.ai/api/search-image?query=real%20photo%20of%20a%20British%20woman%20aged%2035%2C%20long%20dark%20blonde%20hair%2C%20wearing%20a%20smart%20navy%20jacket%20over%20a%20light%20blouse%2C%20sitting%20at%20a%20meeting%20table%20in%20a%20bright%20modern%20British%20office%2C%20warm%20natural%20daylight%2C%20warm%20genuine%20smile%2C%20candid%20not%20posed%2C%20editorial%20corporate%20photography%20style%2C%20shallow%20focus%2C%20blurred%20whiteboards%20and%20meeting%20room%20behind%2C%20authentic%20real%20person&width=400&height=480&seq=435&orientation=portrait",
  },
  {
    name: "Edward Ashford",
    role: "Property Acquisition Director",
    bio: "Edward leads property sourcing, due diligence, and acquisition across England and Wales. Joining in 2012 after a career in residential and commercial development in Yorkshire and the East Midlands, he has personally overseen every acquisition in the current portfolio and maintains the firm's relationships with housing associations and local authorities.",
    image: "https://readdy.ai/api/search-image?query=real%20photo%20of%20a%20British%20man%20aged%2042%2C%20short%20light%20brown%20hair%2C%20slight%20stubble%2C%20wearing%20a%20casual%20blue%20open%20collar%20shirt%2C%20standing%20outside%20a%20red%20brick%20Yorkshire%20building%20on%20an%20overcast%20day%2C%20natural%20daylight%2C%20relaxed%20friendly%20expression%2C%20candid%20editorial%20documentary%20photography%2C%20shallow%20depth%20of%20field%2C%20authentic%20not%20staged%2C%20real%20person%20outdoors&width=400&height=480&seq=436&orientation=portrait",
  },
];

const values = [
  { icon: "ri-shield-check-line", title: "Investor First", desc: "Every structural decision is made with the security and interests of our investors as the primary consideration — from first legal charges to independent trustee arrangements." },
  { icon: "ri-eye-line", title: "Full Transparency", desc: "We provide clear, complete information through detailed reporting, regular updates, and unrestricted access to our investment team throughout the term." },
  { icon: "ri-home-heart-line", title: "Social Impact", desc: "Our investments directly support the delivery of assisted living and supported housing to vulnerable adults across the UK — generating genuine social value alongside financial returns." },
  { icon: "ri-book-open-line", title: "Regulatory Compliance", desc: "All financial promotions are issued in compliance with Section 21 of FSMA 2000. We operate within the bounds of UK financial services regulation at all times." },
];

const milestones = [
  {
    year: "Jun 2005",
    title: "Company Founded",
    desc: "Thorpe Property Development Ltd incorporated in Leeds, Yorkshire. Founded on the conviction that UK social housing represented one of the most undersupplied and government-supported asset classes in the country.",
  },
  {
    year: "2006",
    title: "First Acquisition",
    desc: "Secured our first assisted living property in West Yorkshire — an 8-bedroom supported housing facility leased to a registered housing association under a 15-year agreement.",
  },
  {
    year: "2008",
    title: "Resilience Through the Crisis",
    desc: "While global financial markets collapsed, our social housing portfolio remained unaffected. Government-backed lease income continued uninterrupted — validating the recession-proof nature of the asset class.",
  },
  {
    year: "2010",
    title: "£2M Assets Under Management",
    desc: "Reached our first major milestone of £2M in assets under management across a portfolio of four properties. Began attracting interest from high net worth investors seeking government-backed income.",
  },
  {
    year: "2013",
    title: "Housing Association Partnership",
    desc: "Signed our first formal long-term partnership with a UK-registered housing association, establishing the FRI lease model — full repairing and insuring leases with CPI + 1% rent escalation — that underpins all of our products today.",
  },
  {
    year: "2015",
    title: "First Structured Investment Product",
    desc: "Launched our first structured investment product for certified high net worth individuals, offering monthly income backed by assisted living assets. Oversubscribed within six weeks of launch.",
  },
  {
    year: "2017",
    title: "£10M AUM Milestone",
    desc: "Grew assets under management to £10M across 8 properties. Expanded the team, brought in an independent Security Trustee structure, and established first legal charge security across the entire portfolio.",
  },
  {
    year: "2018",
    title: "International Expansion",
    desc: "Listed our first product on NASDAQ Dubai, opening the portfolio to international investors. This marked Thorpe Dellow's entry into the multi-jurisdiction structured investment space.",
  },
  {
    year: "2020",
    title: "10 Properties, 2,000+ Residents",
    desc: "Expanded to 10 assisted living properties across England and Wales, providing homes for over 2,000 vulnerable adults. Maintained 100% lease income compliance throughout the Covid-19 pandemic.",
  },
  {
    year: "2022",
    title: "Thorpe Dellow Brand Launch",
    desc: "Launched the Thorpe Dellow investment brand, consolidating all structured investment activities under a single identity for institutional and private investors.",
  },
  {
    year: "2023",
    title: "10.00% p.a. Product Launch",
    desc: "Launched the flagship 5-Year Social Housing Structured Product targeting 10.00% per annum, distributed monthly. Within the first year, the product attracted investment from across the UK and internationally.",
  },
  {
    year: "2026",
    title: "20th Anniversary — £47M+ AUM",
    desc: "Celebrating 20 years in operation with over £47M assets under management, 545+ residential units across 35 properties in England, Wales and Scotland. A two-decade track record built on the same principles we started with in June 2005.",
  },
];

export default function AboutPage() {
  return (
    <main className="min-h-screen bg-[#EEF2F9]">
      <Navbar />

      {/* Hero */}
      <section
        className="relative pt-32 pb-20 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=aerial%20panoramic%20view%20of%20Leeds%20city%20centre%20Yorkshire%20England%20skyline%20of%20modern%20and%20traditional%20architecture%20River%20Aire%20warm%20golden%20hour%20light%20financial%20district%20buildings%20wide%20drone%20cinematic%20photography%20no%20people%20professional%20real%20estate%20investment%20backdrop&width=1400&height=420&seq=802&orientation=landscape')",
        }}
      >
        <div className="absolute inset-0 bg-[#071A2E]/70" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-white">
          <span className="inline-block text-[#C9A84C] text-xs font-semibold uppercase tracking-widest mb-4">
            Est. June 2005 · Leeds, Yorkshire
          </span>
          <h1
            className="text-4xl md:text-5xl font-bold mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            About Thorpe Dellow
          </h1>
          <p className="text-white/70 text-sm max-w-xl">
            Twenty years of specialist social housing investment — delivering structured, income-generating products backed by UK assisted living assets since 2005.
          </p>
        </div>
      </section>

      {/* FSMA Notice */}
      <section className="bg-[#071A2E] border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5">
          <div className="flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center text-[#C9A84C] flex-shrink-0 mt-0.5">
              <i className="ri-error-warning-line leading-none" />
            </div>
            <p className="text-slate-300 text-xs leading-relaxed">
              <strong className="text-[#C9A84C]">Important Notice (Section 21 FSMA 2000):</strong> Financial promotions issued by Thorpe Dellow are intended solely for Certified High Net Worth Individuals, Self-Certified Sophisticated Investors, or eligible retail investors. Investments involve risk. Capital may be at risk. Past performance is not indicative of future results.
            </p>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="bg-[#EEF2F9] py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">Est. June 2005</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#071A2E] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Two Decades of<br /><span className="text-[#C9A84C]">Building Something Real</span>
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed max-w-2xl mx-auto">
              Founded in Leeds in June 2005, Thorpe Property Development Ltd — trading as Thorpe Dellow — has grown from a single West Yorkshire acquisition into one of the UK's most respected specialist social housing investment firms. This is our story.
            </p>
          </div>
          <div className="relative">
            <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-[2px] -translate-x-1/2" style={{ background: "linear-gradient(to bottom, transparent 0%, #C9A84C 8%, #C9A84C 92%, transparent 100%)" }} />
            <div className="flex flex-col gap-0">
              {milestones.map((m, i) => (
                <div key={m.year} className={`relative flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-0 ${i % 2 === 0 ? "lg:flex-row" : "lg:flex-row-reverse"}`}>
                  <div className={`w-full lg:w-[calc(50%-2.5rem)] ${i % 2 === 0 ? "lg:pr-10 lg:text-right" : "lg:pl-10"}`}>
                    <div className="bg-white rounded-2xl p-6 mb-4 lg:mb-8 hover:border-[#C9A84C]/30 border border-transparent transition-all" style={{ boxShadow: "0 2px 16px rgba(7,26,46,0.06)" }}>
                      <span className="inline-block text-[10px] font-bold text-[#C9A84C] uppercase tracking-[0.2em] bg-[#C9A84C]/10 px-3 py-1 rounded-full mb-3">{m.year}</span>
                      <h3 className="text-base font-bold text-[#071A2E] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{m.title}</h3>
                      <p className="text-slate-500 text-xs leading-relaxed">{m.desc}</p>
                    </div>
                  </div>
                  <div className="hidden lg:flex w-20 flex-shrink-0 items-center justify-center z-10">
                    <div className="w-4 h-4 rounded-full border-2 border-[#C9A84C] bg-white" style={{ boxShadow: "0 0 12px rgba(201,168,76,0.4)" }} />
                  </div>
                  <div className="hidden lg:block w-[calc(50%-2.5rem)]" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="bg-white py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-4">Our Mission</span>
              <h2 className="text-3xl md:text-4xl font-bold text-[#071A2E] leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                Where Social Impact<br />Meets <span className="text-[#C9A84C]">Structured Returns</span>
              </h2>
              <p className="text-slate-500 text-sm leading-relaxed mb-5">
                Founded in June 2005, Thorpe Dellow is a specialist alternative investment firm focused exclusively on the UK social housing sector. Over two decades, we have designed and managed structured investment products that give qualified investors access to the stable, government-supported cash flows generated by assisted living and supported housing assets.
              </p>
              <p className="text-slate-500 text-sm leading-relaxed mb-8">
                Our current flagship product — the Thorpe Dellow Social Housing Structured Product — targets a 10.00% per annum return, paid monthly, backed by long-term lease agreements with UK-registered housing associations. Every investment is secured by first legal charges over underlying properties.
              </p>
              <div className="grid grid-cols-3 gap-4">
                {[
                  { value: "20 Yrs", label: "In Operation" },
                  { value: "£47M+", label: "Assets Under Management" },
                  { value: "35", label: "Properties Acquired" },
                ].map((s) => (
                  <div key={s.label} className="text-center bg-[#EEF2F9] rounded-2xl py-6">
                    <p className="text-xl font-bold text-[#C9A84C]" style={{ fontFamily: "'Playfair Display', serif" }}>{s.value}</p>
                    <p className="text-xs text-slate-400 mt-1">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="w-full h-[460px] rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20neat%20modern%20UK%20residential%20housing%20estate%20in%20Yorkshire%2C%20rows%20of%20clean%20red%20brick%20two%20storey%20houses%20with%20well%20maintained%20gardens%20and%20driveways%2C%20tree%20lined%20streets%2C%20overcast%20British%20sky%2C%20professional%20real%20estate%20investment%20portfolio%20photography%2C%20no%20people%2C%20wide%20angle%20drone%20shot%2C%20investment%20grade%20residential%20property%2C%20tidy%20suburban%20development&width=700&height=460&seq=803&orientation=portrait"
                  alt="Thorpe Dellow social housing assets"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-6 left-6 bg-white rounded-2xl px-6 py-4">
                <p className="text-xs text-slate-400 mb-0.5">Established</p>
                <p className="text-sm font-bold text-[#071A2E]">June 2005</p>
                <p className="text-xs text-[#C9A84C] font-semibold">Leeds, Yorkshire</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="bg-[#EEF2F9] py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">Our Principles</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#071A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>Our Core Values</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v) => (
              <div key={v.title} className="bg-white rounded-2xl p-8 text-center">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#C9A84C]/10 mx-auto mb-5">
                  <i className={`${v.icon} text-2xl text-[#C9A84C] leading-none`} />
                </div>
                <h3 className="font-bold text-[#071A2E] text-base mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{v.title}</h3>
                <p className="text-slate-500 text-xs leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="bg-white py-20 md:py-24">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">The Team</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#071A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>Meet Our People</h2>
            <p className="text-slate-500 text-sm mt-3 max-w-xl mx-auto leading-relaxed">
              A tight-knit team of specialists who have been with Thorpe Dellow through every chapter — from the first acquisition in 2006 to the NASDAQ Dubai listing and beyond.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {team.map((m) => (
              <article key={m.name} className="group bg-[#EEF2F9] rounded-2xl overflow-hidden border border-transparent hover:border-[#C9A84C]/20 transition-all" style={{ boxShadow: "0 2px 16px rgba(7,26,46,0.05)" }}>
                <div className="w-full h-72 overflow-hidden">
                  <img
                    src={m.image}
                    alt={m.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-bold text-[#071A2E] text-base mb-0.5" style={{ fontFamily: "'Playfair Display', serif" }}>{m.name}</h3>
                  <p className="text-[#C9A84C] text-xs font-semibold mb-3 uppercase tracking-wide">{m.role}</p>
                  <div className="w-8 h-[1.5px] rounded-full mb-3" style={{ background: "linear-gradient(90deg, #C9A84C, #E2C27A)" }} />
                  <p className="text-slate-500 text-xs leading-relaxed">{m.bio}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory strip */}
      <section className="bg-[#071A2E] py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-slate-400 text-xs uppercase tracking-widest mb-6">Compliance &amp; Regulation</p>
          <p className="text-slate-300 text-xs leading-relaxed max-w-3xl mx-auto mb-4">
            Thorpe Property Development Ltd (Company No. 07590563), trading as Thorpe Dellow. Registered in England and Wales. Registered office: One Embankment, Leeds LS1 4DW, United Kingdom. Financial promotions issued in accordance with Section 21 of the Financial Services and Markets Act 2000 (FSMA). All promotions are directed solely at persons who qualify as Certified High Net Worth Individuals, Self-Certified Sophisticated Investors, or eligible retail investors.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-6">
            {["FSMA 2000 Compliant", "Section 21 Financial Promotion", "FCA Guidance Aligned", "Independent Security Trustee", "UK Registered SPV"].map((p) => (
              <span key={p} className="text-white/50 text-sm font-medium">{p}</span>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
